<template>
  <div
    class="chat-image-lightbox"
    :class="{ 'chat-image-lightbox--open': visible }"
    :aria-hidden="!visible"
    role="dialog"
    aria-modal="true"
    @click.self="onClose"
  >
    <button
      type="button"
      class="chat-image-lightbox__close"
      aria-label="بستن"
      tabindex="0"
      @click.stop="onClose"
    >
      <i class="mdi mdi-close" aria-hidden="true"></i>
    </button>
    <div class="chat-image-lightbox__stage" @click.stop>
      <img
        v-if="src"
        :src="src"
        class="chat-image-lightbox__img"
        alt=""
        @click.stop
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatImageLightbox',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible (open) {
      document.body.style.overflow = open ? 'hidden' : ''
    }
  },
  mounted () {
    document.body.appendChild(this.$el)
    this._onKeydown = (e) => {
      if (e.key === 'Escape' && this.visible) {
        this.onClose()
      }
    }
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._onKeydown)
    document.body.style.overflow = ''
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.chat-image-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem 1rem;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.22s ease, background-color 0.22s ease, visibility 0.22s ease;
  cursor: zoom-out;
}

.chat-image-lightbox--open {
  background: rgba(0, 0, 0, 0.88);
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.chat-image-lightbox__close {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;
}

.chat-image-lightbox__close:hover {
  background: rgba(255, 255, 255, 0.28);
}

.chat-image-lightbox__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: min(96vw, 1200px);
  max-height: 90vh;
  cursor: default;
}

.chat-image-lightbox__img {
  display: block;
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  user-select: none;
  pointer-events: none;
}
</style>
